import './index.scss';
import data from './data.json';
import {
  getRandomInt,
  shuffleArray,
  pluralize,
} from '../../shared/utils';

const dataRealUsers = data.filter(user => user.imgId);

class App {
  dom = {};
  ctx = null;
  imgAngel = null;
  imgHeart = null;
  usersImgs = {};

  constructor({rootEl}) {
    this.cacheDomEls(rootEl);
    this.initCanvas();
    this.bindEvents();
    this.showAppCountText();
    this.loadAssetsAndShowContent();
  }

  cacheDomEls(rootEl) {
    const dom = this.dom;
    dom.root = rootEl;
    dom.loader = rootEl.querySelector('.loaderContainer');
    dom.content = rootEl.querySelector('.app-content');
    dom.canvas = rootEl.querySelector('.app-canvas');
    dom.angel = rootEl.querySelector('.angel');
    dom.countText = rootEl.querySelector('.app-count');
  }

  initCanvas() {
    const {canvas} = this.dom;

    const ctx = canvas.getContext('2d');
    canvas.style.width = canvas.width / 2 + 'px';
    canvas.style.height = canvas.height / 2 + 'px';
    ctx.scale(2,2); // For retina
    this.ctx = ctx;
  }

  bindEvents() {

  }

  loadAssetsAndShowContent() {
    const {root, loader, content} = this.dom;

    const imgHeart = new Image();
    const imgHeartPromise = new Promise((resolve, reject) => {
      imgHeart.onload = () => {
        resolve();
      };
      imgHeart.onerror = (error) => {
        reject(error);
      };
      imgHeart.src = 'assets/i/h/h-red.png';
    });

    const imgAngel = new Image();
    const imgAngelPromise = new Promise((resolve, reject) => {
      imgAngel.onload = () => {
        resolve();
      };
      imgAngel.onerror = (error) => {
        reject(error);
      };
      imgAngel.src = 'assets/i/angel.png';
    });

    const usersImgsPromises = data
      .filter(user => user.imgId)
      .map(user => {
      return new Promise((resolve, reject) => {
        const {imgId} = user;
        const img = new Image();
        const src = `assets/i/users/${imgId}.jpg`;
        img.onload = () => {
          resolve();
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = src;

        this.usersImgs[imgId] = img;
      });
    })

    Promise.all([imgHeartPromise, imgAngelPromise].concat(usersImgsPromises)).then(data => {
      this.imgAngel = imgAngel;
      this.imgHeart = imgHeart;

      root.classList.remove('is-loading');
      root.classList.add('is-loaded');
      setTimeout(() => {
        content.classList.add('is-visible');
        loader.classList.remove('is-visible');

        this.render();
        this.animateAngel();
      }, 500);
    }).catch(error => {
      console.error(error);
    });
  }

  render = () => {
    const {ctx, imgHeart, imgAngel, usersImgs} = this;

    data.forEach(user => {
      const {x, y, imgId} = user;
      if (!imgId) {
        const size = getRandomInt(9,21);
        ctx.drawImage(imgHeart, getRandomInt(x-3, x+3), getRandomInt(y-3, y+3), size, size);
      }
    });

    data.forEach(user => {
      const {x, y, imgId} = user;
      if (imgId) {
        const img = usersImgs[imgId];
        ctx.drawImage(img, x, y, 18, 18);
      }
    });

    // requestAnimationFrame(this.render);
  };

  animateAngel = () => {
    let index = 1;
    let frameCount = 3;
    const angel = this.dom.angel;
    setInterval(() => {
      if (index > frameCount) {
        index = 1;
      }
      angel.classList.remove(`is-frame1`);
      angel.classList.remove(`is-frame2`);
      angel.classList.remove(`is-frame3`);
      angel.classList.add(`is-frame${index}`);
      index++;

    }, 500);

    this.moveAngelToRandomUser();
  };

  moveAngelToRandomUser = () => {
    const users = dataRealUsers;
    const randomUsers = shuffleArray(users);
    const {x, y} = randomUsers[0];
    this.dom.angel.style.transform = `translate(${x}px, ${y}px)`;

    this.moveAngelTimeout = setTimeout(() => {
      this.moveAngelToRandomUser();
    }, getRandomInt(15, 20) * 1000);
  }

  showAppCountText() {
    const {countText} = this.dom;
    const heartCount = data.length;
    const heartCountPluralized = pluralize(heartCount, 'сердце', 'сердца', 'сердец');

    const text = `Отправлено ${heartCount} ${heartCountPluralized}`;

    countText.innerText = text;
  }
}

export default App;
window.App = App;



/** WEBPACK FOOTER **
 ** ./src/client/panorama/index.js
 **/